import { useEffect } from 'react'
import PropTypes from 'prop-types'

import { parseAiUsageHash } from '@/core/helpers/profileAnchors'

const ScrollTop = ({ location, children }) => {
  const { pathname, search, hash } = location

  // This runs after the arriving page's own effects, so it would undo a scroll the anchor asked
  // for. Not a dependency: clearing a spent hash is not a navigation.
  useEffect(() => {
    if (parseAiUsageHash(hash)) return

    window.scrollTo(0, 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search])

  return children
}

ScrollTop.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
  }),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default ScrollTop
